import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowUpRight, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const { t } = useTranslation();

  const quickLinks = [
    { to: '/', label: t('nav.home') },
    { to: '/about', label: t('nav.about') },
    { to: '/services', label: t('nav.services') },
    { to: '/blog', label: t('nav.blog') },
    { to: '/contact', label: t('nav.contact') },
  ];

  const services = [
    t('services.financial.title'),
    t('services.project.title'),
    t('services.sector.title'),
  ];

  return (
    <footer data-testid="footer" className="bg-[#0A1423] border-t border-[#C9A84C]/10">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        {/* Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link
              to="/"
              className="font-heading text-2xl font-bold text-[#C9A84C] tracking-wide"
            >
              BEU DANIŞMANLIK
            </Link>
            <p className="mt-6 text-white/50 text-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-white mb-6">
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-4">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-white/50 hover:text-[#C9A84C] transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-white mb-6">
              {t('footer.services')}
            </h4>
            <ul className="space-y-4">
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to="/services"
                    className="text-white/50 hover:text-[#C9A84C] transition-colors text-sm"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-white mb-6">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-[#C9A84C] mt-1 flex-shrink-0" />
                <div className="flex flex-col gap-1">
                  <a href="tel:+905422235319" className="text-white/50 text-sm hover:text-[#C9A84C] transition-colors">0542 223 53 19</a>
                  <a href="tel:+905422236173" className="text-white/50 text-sm hover:text-[#C9A84C] transition-colors">0542 223 61 73</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-[#C9A84C] mt-1 flex-shrink-0" />
                <a href="mailto:info@beudanismanlik.com" className="text-white/50 text-sm hover:text-[#C9A84C] transition-colors">info@beudanismanlik.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#C9A84C] mt-1 flex-shrink-0" />
                <span className="text-white/50 text-sm leading-relaxed">Büyükdere Caddesi, Astoria İş Kuleleri No:127 34394 Esentepe, Şişli, İstanbul</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#C9A84C]/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/30 text-sm">
              © {new Date().getFullYear()} BEU Danışmanlık. {t('footer.rights')}
            </p>
            <div className="flex items-center gap-6">
              <Link to="/admin" className="text-white/30 hover:text-white/50 text-sm transition-colors">
                Admin
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
